
<div>
  <nav id="deal-nav" dense
    mat-tab-nav-bar
    [tabPanel]="tabPanel"
    style="width: 100%"
    [ngStyle]="{'background-color': theme.subheader_bg}"
  >

    <!-- ISSUER APPROVALS  -->
    <a mat-tab-link
      [hasPermission]="util.Permission.CAN_ACCESS_APPROVALS_ISSUER"
      routerLink="issuer"
      routerLinkActive="active-link"
    >
      Issuer & Deal Approvals 
    </a>

    <!-- INVESTOR APPROVALS  -->
    <a mat-tab-link
      [hasPermission]="util.Permission.CAN_ACCESS_APPROVALS_INVESTOR"
      routerLink="investor"
      routerLinkActive="active-link"
    >
      Investor & Mandate Approvals
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>

